import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import TicketItems from "../../components/tickets/TicketDetails/TicketItems";

import { useParams } from "react-router-dom";

const TicketsDetails = () => {
  const params = useParams();

  return (
    <Box sx={{ maxWidth: "1600px", margin: "0 auto" }}>
      <Box
        sx={{
          marginTop: "40px",
          marginBottom: "30px",
        }}
      >
        <Typography>Correlate information across tickets</Typography>
      </Box>
      {params?.id && <TicketItems />}{" "}
      {!params?.id && (
        <>
          <TicketItems />
          <TicketItems />
          <TicketItems />
        </>
      )}
    </Box>
  );
};

export default TicketsDetails;
